import { useQuery } from '@tanstack/react-query';

const useUmbracoOfficeNews = <T,>(pageId: string, nodeName: string) => {
  return useQuery<T>(
    ['umbracoOfficeNews', pageId, nodeName],
    async () => {
      // Fetch all descendants of the given pageId
      const response = await fetch(
        `/umbraco/delivery/api/v2/content?fetch=descendants:${pageId}&fields=name,id`
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      // Find the child node with the specified nodeName
      const targetNode = data.items.find(
        (item: { name: string }) => item.name === nodeName
      );

      if (!targetNode) {
        throw new Error(`Node with name "${nodeName}" not found`);
      }

      // Fetch all descendants of the found node
      const descendantsResponse = await fetch(
        `/umbraco/delivery/api/v2/content?fetch=descendants:${targetNode.id}&sort=name:asc&fields=properties[heading,image,text,preamble]&take=300`
      );

      if (!descendantsResponse.ok) {
        throw new Error('Failed to fetch descendants');
      }

      return descendantsResponse.json();
    },
    {
      enabled: !!pageId && !!nodeName, // Only run query if pageId and nodeName are not empty
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 5 * 60,
      staleTime: 1000 * 5 * 60,
    }
  );
};

export default useUmbracoOfficeNews;
